import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

const getWorkflowTemplates = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'workflowTemplates'), params)
}

const getWorkflowTemplate = (application, templateId, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'workflowTemplates') + `/${templateId}`, params)
}

const createWorkflowTemplate = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'workflowTemplates'), params)
}

const deleteWorkflowTemplate = (workflowTemplate) => {
  return clientHTTP.delete(getLinkHref(workflowTemplate, 'self'))
}

const startWorkflowTemplate = (workflowTemplate, params = {}, headers = {}) => {
  return clientHTTP.post(getLinkHref(workflowTemplate, 'self'), params, headers)
}

const getWorkflowProcesses = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'workflowProcesses'), params)
}

const getWorkflowProcessInstances = (application, processId, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'workflowProcesses') + `/${processId}/instances`, params)
}

const getWorkflowInstance = (application, instanceId) => {
  return clientHTTP.get(getLinkHref(application, 'workflowInstances') + `/${instanceId}`)
}

const getWorkflowInstanceActivities = (workflowInstance, instanceId) => {
  return clientHTTP.get(getLinkHref(workflowInstance, 'workflowInstanceActivities'))
}

export default {
  getWorkflowTemplates,
  getWorkflowTemplate,
  createWorkflowTemplate,
  deleteWorkflowTemplate,
  startWorkflowTemplate,
  getWorkflowProcesses,
  getWorkflowProcessInstances,
  getWorkflowInstance,
  getWorkflowInstanceActivities
}
